import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthenticationService, TokenService} from '@core/modules/authentication/services';
import {getLoginFormBuilder, getLoginFormFields} from '@core/modules/authentication/components/login/form';
import {FormHelper} from '@shared/helpers/form.helper';
import {AuthLoaders} from '@core/modules/authentication/enums/authentication-loaders.enum';
import {DASHBOARD_ROUTE} from '@core/constants/navigation/navigation.const';
import {BootstrapLicenseDataService, BootstrapLicenseService} from '@core/services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends FormHelper implements OnInit {
  private returnUrl: string;
  public readonly Loaders = AuthLoaders;

  constructor(
    private route: ActivatedRoute,
    private bootstrapLicenseService: BootstrapLicenseService,
    private bootstrapDataLicenseService: BootstrapLicenseDataService,
    private authService: AuthenticationService,
    private tokenService: TokenService
  ) {
    super();
  }

  ngOnInit(): void {
    this.setReturnUrl();
    this.setFormGroup(getLoginFormBuilder, getLoginFormFields);
  }

  private setReturnUrl(): void {
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || DASHBOARD_ROUTE;
  }

  onSubmit(): void {
    this.setAllControlsAsTouched();
    if (this.isFormGroupValid()) {
      this.setLoader(AuthLoaders.Login, true);
      this.authService.login(this.formGroup.value)
        .then((response) => this.tokenService.setToken(response.data.id))
        .then(() => this.bootstrapDataLicenseService.resetBootstrapLicenseData())
        .then(() => this.bootstrapLicenseService.getBootstrapLicense())
        .then(() => this.onGetLicenseInfoSuccess())
        .catch((error) => this.onResponseSavedError(error))
        .finally(() => this.setLoader(AuthLoaders.Login, false));
    }
  }

  onGetLicenseInfoSuccess(): void {
    if (this.bootstrapDataLicenseService.getBootstrapError()) {
      this.authService.softLogout(false);
      this.service.toastr.error('Wystąpił błąd podczas pobierania licencji');
    } else {
      this.service.router.navigateByUrl(this.returnUrl);
    }
  }
}
